import { createSelector, createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';
import http from 'utils/http';

const initialState = {
  error: '',
  pending: false,
  reidVaporPressuresList: [],
};

const reducers = {
  fetchReidVaporPressuresError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchReidVaporPressuresPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchReidVaporPressuresSuccess(state, { payload }) {
    return R.assoc('reidVaporPressuresList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'reidVaporPressures',
  reducers,
});

const {
  fetchReidVaporPressuresPending,
  fetchReidVaporPressuresSuccess,
  fetchReidVaporPressuresError,
} = actions;

// Selectors
const reidVaporPressuresListSelector = state => state.pto.reidVaporPressures.reidVaporPressuresList;

export const reidVaporPressureOptionsSelector = createSelector(
  reidVaporPressuresListSelector,
  reidVaporPressures => [
    {
      label: 'Any',
      value: null,
    },
    ...reidVaporPressures.map(({ value }) => ({
      label: value.toString(),
      value,
    })),
  ]
);

// Actions
let fetchController;
export function fetchReidVaporPressures(params = {}) {
  return dispatch => {
    dispatch(fetchReidVaporPressuresPending(true));
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const { signal } = fetchController;
    return http
      .get('/product-transfer-orders/get-reid-vapor-pressures', { params }, { signal })
      .then(res => {
        dispatch(fetchReidVaporPressuresError(''));
        dispatch(fetchReidVaporPressuresSuccess(res.data));
        dispatch(fetchReidVaporPressuresPending(false));
      })
      .catch(() => {
        // do nothing
      });
  };
}

export default reducer;
